import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { InputSearch } from 'apps/auth/components/form/components/InputSearch';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { COUNTRY_CODE_LIST_OPENED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PHONE_COUNTRY } from 'apps/auth/constants/FieldType';
import { LOGIN_REGISTRATION_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_SEND } from 'apps/auth/constants/UrlConstants';

import FullCountryList from './FullCountryList';
import { FullViewCountrySearch } from './FullViewCountrySearch';
import RecentCountriesWithCode from './RecentCountriesWithCode';

const SelectCountryWithCodeScreen = (props) => {
    const [isFullViewSearch, toggleIsFullViewSearch] = useState(false);

    useEffect(() => {
        if (props.formName === LOGIN_REGISTRATION_FORM_NAME) {
            amplitude.getInstance().logEvent(COUNTRY_CODE_LIST_OPENED, { [PHONE_COUNTRY]: props.countryName });
        }
    }, []);

    const toggleSearch = (e, show) => {
        e.preventDefault();
        toggleIsFullViewSearch(show);
    };

    const fullViewSearchBackUri = props.fullViewSearchBackUri;

    return (
        <>
            {isFullViewSearch ? (
                <FullViewCountrySearch
                    countries={props.isRequest ? props.requestCountries : props.countries}
                    title={props.title}
                    countriesHeader={props.countriesHeader}
                    placeholder={props.fullScreenSearchPlaceholder}
                    searchNoResult={props.searchNoResult}
                    toggleSearch={toggleSearch}
                    onCountryItemClick={props.onCountryItemClick}
                    backUrl={fullViewSearchBackUri}
                    countryWithCode={props.countryWithCode}
                    iso2={props.iso2}
                    isRequest={props.isRequest}
                />
            ) : (
                <ModalComponent isIconClose onCloseIconClick={props.closeModal} modalRef={props.modalRef}>
                    <HeaderPanel title={props.title} />
                    {!props.isRequest && props.suggestedCountries?.length > 0 && (
                        <>
                            <Row indent="48px">
                                <RecentCountriesWithCode
                                    countries={props.countries}
                                    suggestedCountries={props.suggestedCountries}
                                    suggested={props.suggested}
                                    iso2={props.iso2}
                                    onCountryItemClick={props.onCountryItemClick}
                                    countryWithCode={props.countryWithCode}
                                />
                            </Row>
                            <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                                {props.allCountries}
                            </Text>
                        </>
                    )}
                    <InputSearch placeholder={props.searchPlaceholder} toggle={toggleSearch} />
                    <FullCountryList
                        countries={props.isRequest ? props.requestCountries : props.countries}
                        iso2={props.iso2}
                        onCountryItemClick={props.onCountryItemClick}
                        countryWithCode={props.countryWithCode}
                        isRequest={props.isRequest}
                    />
                </ModalComponent>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
        countries: state.extra.countries,
        suggestedCountries: state.extra.suggestedCountries,
        title: state.messages.pageMessages.title,
        countriesHeader: state.messages.pageMessages.countriesHeader,
        searchPlaceholder: state.messages.pageMessages.searchPlaceholder,
        fullScreenSearchPlaceholder: state.messages.pageMessages.fullScreenSearchPlaceholder,
        searchNoResult: state.messages.pageMessages.searchNoResult,
        allCountries: state.messages.pageMessages.allCountries,
        suggested: state.messages.pageMessages.suggested,
        fullViewSearchBackUri: AUTH_SEND,
    };
};

export default connect(mapStateToProps, { toggleModal })(SelectCountryWithCodeScreen);
